import React,{useState} from 'react'
import Flatpickr from 'react-flatpickr';

function SearchBar({handleSearchChange,searchCriteria,handleSearchCriteriaChange,handleReset}) {
    const [searchTerm, setSearchTerm] = useState('');

    const handleDateChange = (selectedDate) => {
        setSearchTerm(selectedDate[0].toISOString().split('T')[0]); // Save the selected date as YYYY-MM-DD
      };
    const handleSearchTermChange = (event) => {
        console.log("SearchTermChange")
        console.log(event.target.value)
        setSearchTerm(event.target.value);
    };
    const handleTxtReset = ()=>{
        setSearchTerm('')
        handleReset()
    }
  return (
    <div className="card p-4 mb-3 rounded">
    <div className="mb-3">
        <div className="input-group flex-nowrap">
                 {searchCriteria === 'date' ? (
                       <Flatpickr
                       className="form-control form-control-sm"
                       value={searchTerm}
                       onChange={handleDateChange}
                       options={{ 
                            dateFormat: 'Y-m-d',
                            maxDate:'today'
                        
                        }}
                     />
                    ) : (
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder={searchCriteria === 'date' ? 'YYYY-MM-DD' : 'Search'}
                            onChange={handleSearchTermChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchChange(searchTerm);
                                }
                            }}
                            value={searchTerm}
                        />
                    )}      
              
                 <button className="btn btn-light-primary  btn-sm" onClick={()=>handleSearchChange(searchTerm)}><i className='bi bi-search'></i> </button>
                 {searchTerm.length >0 ? <button className="btn btn-sm btn-light-danger" onClick={handleTxtReset}><i className='bi bi-x-circle'></i></button> :""}
        </div>
       
    </div>
<div className="">
    <div className="form-check form-check-inline">
      <input
            className="form-check-input"
            type="radio"
            name="searchCriteria"
            id="firstName"
            value="firstName"
            checked={searchCriteria === 'firstName'}
            onChange={handleSearchCriteriaChange}
        />
        <label className="form-check-label fs-7" htmlFor="firstName">
            First Name
        </label>
     </div>
    <div className="form-check form-check-inline">
        <input
            className="form-check-input"
            type="radio"
            name="searchCriteria"
            id="lastName"
            value="lastName"
            checked={searchCriteria === 'lastName'}
            onChange={handleSearchCriteriaChange}
        />
        <label className="form-check-label fs-7" htmlFor="lastName">
            Last Name
        </label>
    </div>
    <div className="form-check form-check-inline">
            <input
                className="form-check-input"
                type="radio"
                name="searchCriteria"
                id="cell"
                value="cell"
                checked={searchCriteria === 'cell'}
                onChange={handleSearchCriteriaChange}
            />
            <label className="form-check-label fs-7" htmlFor="phoneNumber">
                Phone
            </label>
    </div>
    <div className="form-check form-check-inline">
            <input
                className="form-check-input"
                type="radio"
                name="searchCriteria"
                id="searchDate"
                value="date"
                checked={searchCriteria === 'date'}
                onChange={handleSearchCriteriaChange}
            />
            <label className="form-check-label fs-7" htmlFor="date">
                Date
            </label>
    </div>
 </div>
 

</div>
  )
}

export default SearchBar